module.exports = __webpack_public_path__ + "img/4.9dcbb27f.jpg";